module.exports = __webpack_public_path__ + "static/media/use_esim_zhcn4.8fe1fdff.png";